export default "__VITE_ASSET__df297740__"